/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Company } from '../../models/company';
import { CompanyApiRespModel } from '../../models/company-api-resp-model';

export interface ApiMasterCompanyEditPost$Params {
      body?: Company
}

export function apiMasterCompanyEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterCompanyEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCompanyEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyApiRespModel>;
    })
  );
}

apiMasterCompanyEditPost.PATH = '/api/Master/Company/Edit';
